import { Component } from 'react';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { dateFormatUK } from '../../../utils/commonFunctions';

import './submission.css';

class Submission extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleClick() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const { submission } = this.props;

    return (
      <Row
        className={`submission-container is-${submission.attributes.status}`}
      >
        <Col className="submission-detail" xs={2}>
          <div>{dateFormatUK(submission.attributes['created-at'])}</div>
        </Col>
        <Col className="submission-detail" xs={2}>
          <div>{submission.attributes.type}</div>
        </Col>
        <Col className="submission-detail" xs={3}>
          <div>{submission.attributes['campaign-name']}</div>
        </Col>
        <Col className="submission-detail status" xs={2}>
          <div>{submission.attributes.status}
            &nbsp;
            {submission.attributes.status === 'declined' && submission.attributes['decline-reason'] &&
              (
                <OverlayTrigger
                  overlay={(
                    <Tooltip className="tooltip grey" id="tooltip">
                      {submission.attributes['decline-reason']}
                    </Tooltip>
                  )}
                  placement="right"
                >
                  <i className="fa fa-info-circle" aria-hidden="true"/>
                </OverlayTrigger>
              )
            }
          </div>
        </Col>
      </Row>
    );
  }
}

export default Submission;
